import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import PropTypes from "prop-types";
import "./DocumentItem.scss";

// TAD-5644 — Vite-native SVG-as-component via `?react` query suffix
// (vite-plugin-svgr). Vitest shares the Vite transform pipeline, so this
// works in tests too.
import MsWordIcon from "../../../../../assets/icons/Icon - MS Word.svg?react";
import MsExcelIcon from "../../../../../assets/icons/Icon - MS Excel.svg?react";
import MsPowerpointIcon from "../../../../../assets/icons/Icon - MS Powerpoint.svg?react";

import DocxIcon from "../../../../../assets/icons/Icon - Word.svg?react";
import PptIcon from "../../../../../assets/icons/Icon - PowerPoint.svg?react";
import ExcelIcon from "../../../../../assets/icons/Icon - Excel.svg?react";

import DownloadIcon from "../../../../../assets/icons/Icon - Download - 15px.svg?react";

const getIcon = (documentName) => {
    let extension = documentName.toLowerCase().substring(documentName.lastIndexOf('.')+1, documentName.length) || documentName;
    switch (extension) {
        case "docx":
            return <MsWordIcon className="file-icon" />;
        case "pptx":
            return <MsPowerpointIcon className="file-icon" />;
        case "xlsx":
            return <MsExcelIcon className="file-icon" />;
        case "doc":
            return <DocxIcon className="file-icon" />;
        case "ppt":
            return <PptIcon className="file-icon" />;
        case "xls":
            return <ExcelIcon className="file-icon" />;
        default:
            return <MsWordIcon className="file-icon" />;
    }
}

const DocumentItem = ({id, documentName, onSelect}) => {
    return (
        <ListGroup.Item className="document-item" onClick={() => onSelect(id)}>
            <span className="item-container">
                {getIcon(documentName)}
                <p className="item-text" title={documentName.length > 37 ? documentName : ""}>
                    {
                    documentName.length > 37 ?
                        documentName.substring(0,36) + "..."
                    :
                        documentName
                    }
                </p>
                <DownloadIcon className="download-icon" />
            </span>
        </ListGroup.Item>
    );
}

DocumentItem.propTypes = {
    id: PropTypes.number.isRequired,
    documentName: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired
}

export default DocumentItem;